import { IcTotalFinancingReceived } from "@/assets/Icons";
import { numberWithCommas } from "@/constants/extensions";
import useAuth from "@/hooks/useAuth";
import { fetchTotalFinancingReceived } from "@/services/api";
import { useQuery } from "@tanstack/react-query";
import Loader from "./Loader";

const BalanceCard = () => {
  const { companyId } = useAuth();

  const { data: totalFinancingReceived = [], isLoading } = useQuery({
    queryKey: ["getTotalFinancingReceived"],
    queryFn: () => fetchTotalFinancingReceived(),
    enabled: !!companyId,
    select: (data) => data.data,
  });

  return (
    <div className="bg-white p-4 grow flex flex-column rounded-lg">
      <div className="flex flex-row gap-4 items-start">
        <IcTotalFinancingReceived />
        <div className="flex flex-column gap-2">
          <span className="body-small-regular text-monochrome-30">Total Financing Received</span>
          {isLoading ? (
            <Loader isLoading={isLoading} />
          ) : (
            <h1>
              {numberWithCommas(totalFinancingReceived.totalFinancing)} <span className="text-monochrome-30 leading-6 text-base">USD</span>
            </h1>
          )}
        </div>
      </div>
    </div>
  );
};

export default BalanceCard;
